import { NIL } from "uuid";
import IArea, { EmptyArea } from "./IArea";

export default interface IAddress {
  id: string;
  clientId?: string;
  name: string;
  city: string;
  town: string;
  village: string;
  district: string;
  neighborhood: string;
  block: string;
  street: string;
  alley: string;
  postalCode: string;
  poBox: string;
  description: string;
  compoundName: string;
  buildingName: string;
  buildingNumber: string;
  floor: string;
  unit: string;
  note: string;
  longitude: string;
  latitude: string;
  isDefault: boolean;
  areaId: string;
  area: IArea;
}

export const EmptyAddress: IAddress = {
  id: NIL,
  clientId: NIL,
  name: "",
  city: "",
  town: "",
  village: "",
  district: "",
  neighborhood: "",
  block: "",
  street: "",
  alley: "",
  postalCode: "",
  poBox: "",
  description: "",
  compoundName: "",
  buildingName: "",
  buildingNumber: "",
  floor: "",
  unit: "",
  note: "",
  longitude: "",
  latitude: "",
  isDefault: false,
  areaId: "",
  area: EmptyArea,
};
